import {IImomoResponse} from './api.types';
import {IDischargeCurveSettings} from '../discharge/curve.controller';

export interface ICurveSettingsRequest {
  minWaterLevel: number;
  maxWaterLevel: number;
  minDischarge: number;
  maxDischarge: number;
  fitViewportToData: boolean;
  siteId: number;
}

export interface ICurveSettingsApi {
  createCurveSettings(curveSettings: IDischargeCurveSettings, siteId: number): ng.IPromise<void>;
  getCurveSettings(siteId: number): ng.IPromise<IDischargeCurveSettings[]>;
}

export default class CurveSettingsApi implements ICurveSettingsApi {
  static $inject = ['backendUrl', '$http'];

  private endpoint: string;

  constructor(backendUrl: string, private $http: ng.IHttpService) {
    this.endpoint = `${backendUrl}/discharge_curve_settings`;
  }

  createCurveSettings(curveSettings: IDischargeCurveSettings, siteId: number): ng.IPromise<void> {

    return this.$http({
      url: this.endpoint,
      method: 'POST',
      data: {
        minWaterLevel: curveSettings.minWaterLevel,
        maxWaterLevel: curveSettings.maxWaterLevel,
        minDischarge: curveSettings.minDischarge,
        maxDischarge: curveSettings.maxDischarge,
        fitViewportToData: curveSettings.fitViewportToData,
        siteId: siteId
      }
    }).then(httpData => {
    });

  }

  getCurveSettings(siteId: number): ng.IPromise<IDischargeCurveSettings[]> {
    return this.$http<IImomoResponse<IDischargeCurveSettings>>({
      url: this.endpoint,
      method: 'GET',
      params: {
        siteId: siteId
      }
    }).then(httpData => httpData.data.resources);
  }

}



/** WEBPACK FOOTER **
 ** ./app/api/curve-settings-api.service.ts
 **/